export default "__VITE_ASSET__CyZOUVYs__"